import { Fragment } from "react";
import "./BlockchainConsulting.css";
import { blockchainConsulting } from "../../staticdata";
import blockchainconsultingbanner from "../../assets/images/services/blockchain/blockchainconsultingbanner.jpg";


const BlockchainConsulting = () => {
  return (
    <Fragment>
      <section className="blockchaincon-style">
        <div className="blockchaincon-banner">
          <div className="row">
            <div className="col-lg-6">
              <div className="blockchaincon-desc">
                <h1
                  className="text-start"
                  data-aos="fade-up-right"
                  data-aos-delay="200"
                  data-aos-duration="1000"
                >
                  Blockchain Consulting
                </h1>
                <p
                  className="text-start"
                  data-aos="fade-up-left"
                  data-aos-delay="200"
                  data-aos-duration="1000"
                >
                  Blockchain is a decentralized system that securely records
                  transactions across a network, acting like a shared,
                  trustworthy ledger. At Kairaa, our blockchain consultants
                  assist businesses in implementing this innovative technology
                  effectively. As a trusted name in blockchain consulting, we
                  provide blockchain development solutions designed to meet your
                  business needs. Let our experts help you prepare your business
                  for the future with secure and reliable blockchain
                  implementations.
                </p>
              </div>
            </div>
            <div className="col-lg-6">
              <div
                className="image-blend-wrapper"
                data-aos="fade-left"
                data-aos-offset="300"
                data-aos-easing="ease-in-sine"
              >
                <img
                  src={blockchainconsultingbanner}
                  alt="image not found"
                  loading="lazy"
                  className=""
                />
              </div>
            </div>
          </div>
        </div>
        <div className="blockchaincon-services">
          <div className="container">
            <div
              className="section-title mt-5 mb-5"
              data-aos="fade-down"
              data-aos-duration="800"
            >
              <h2 className="text-center">
                Our{" "}
                <span className="title-gradient">Blockchain Consulting </span>{" "}
                Service
              </h2>
            </div>
            <div className="row gy-4 d-flex justify-content-center">
              {blockchainConsulting.map((services, index) => (
                <div className="col-lg-4 col-md-6" key={services.id} data-aos="zoom-in">
                  <div className="blockchain-card">
                    <div className="icon-wrap">
                      <img
                        src={services.icon}
                        alt="img not found"
                        style={{ width: "62px", height: "62px" }}
                      />
                    </div>  
                    <h5>{services.title}</h5>
                    <p className="text-light mb-0">{services.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};
export default BlockchainConsulting;
